module.exports = __webpack_public_path__ + "img/Tonga.58674bec.png";